<div class="w-full flex flex-col gap-28 px-28">
  <div class="info h-full flex gap-28">
    <app-token-info class="same-height h-full relative flex-1"></app-token-info>
    <app-contract-type class="same-height h-full flex-1"></app-contract-type>
  </div>
  <app-advanced-options-form></app-advanced-options-form>
</div>
